  <template>
  <div class="pb-64">   
   <div class="vx-card mb-base p-5" v-if="!isWidgetEditID">      
      <h4 class="mb-base mt-2">Widget Type</h4>


      <div class="vx-row">
        <div class="vx-col md:w-3/12 px-5">
          <vs-radio
            v-model="widgetType"
            vs-value="wallofproof"
            class="text-dark mt-2 mb-4 font-medium"
            >Wall of Proof</vs-radio>
          <img class="w-full max-w-xs block mb-base" src="@/assets/images/misc/WOP.png" />
        </div>
        <div class="vx-col md:w-3/12 px-5">
          <vs-radio
            v-model="widgetType"
            vs-value="generalnudge"
            class="text-dark mt-2 mb-4 font-medium"
            >Showcase nudge</vs-radio>
          <img class="w-full max-w-xs block mb-base" src="@/assets/images/misc/GN.png" />
        </div>   
        <div class="vx-col md:w-3/12 px-5">
          <vs-radio
            v-model="widgetType"
            vs-value="carousel"
            class="text-dark mt-2 mb-4 font-medium"
            >Carousel</vs-radio>
          <img class="w-full max-w-xs block mb-base" src="@/assets/images/misc/carousel.png"  />
        </div>       
      </div>
    </div>



    <div class="vx-card mb-base p-5">      
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 px-5">
          <h4 class="mb-base mt-2">Widget Name</h4>      
          <p class="mb-5">You'll use this in future to identify this widget.</p>
          <vs-input name="Widget name" v-validate="'required|max:40'" class="w-100" size="large" v-model="widgetName" placeholder="i.e. 'Homepage Wall of Proof'"/>
          <span class="mt-2 text-danger" v-if="errors.first('Widget name')">{{errors.first('Widget name')}}</span>
        </div>       
        <div class="vx-col w-full md:w-1/2">
          <h4 class="mb-base mt-8 md:mt-2">Items to show</h4>      
      <p class="mb-4">Which items should be displayed in this widget?</p>
      <div class="vx-row">
        
        <div class="vx-col w-full" v-if="$store.state.dash.viewData.currentTags.length > 0">

          <div class="my-2">
            <vs-radio v-model="widgetSettingsData.items.showAllTags" name="alltags" :vs-value="true">Show all showcased items</vs-radio>
          </div>
          <div class="my-2">
            <vs-radio v-model="widgetSettingsData.items.showAllTags" name="alltags" :vs-value="false">Show items with specific tags</vs-radio>
          </div>

          <div v-if="!widgetSettingsData.items.showAllTags" class="mt-4">
            <vs-checkbox class="pr-6 mb-4" v-for="tag in $store.state.dash.viewData.currentTags" :key="tag" v-model="widgetSettingsData.items.showOnlyTags" :vs-value="tag">{{tag}}</vs-checkbox>
          </div>

          <p class="italic mb-4" v-if="widgetSettingsData.items.showOnlyTags.length === 0">If none selected, all items will be included.</p>

        </div>

        <div class="vx-col w-full" v-else>

          <p class="italic mb-4">All items marked for showcase will be included in this widget.</p>

          <p class="mb-4 max-w-lg">If you want to show <span class="italic">specific</span> items in widgets, you can 'tag' showcase items with specific labels. After you've done that, you can specify which tags should be shown in a widget here.</p>

        </div>
      
      </div>

       <div class="vx-row">
        
        <div class="vx-col w-full md:w-1/2">

          <p class="mt-base mb-4">ORDER ITEMS</p>

          <vs-radio class="mb-4 pr-4" v-model="widgetSettingsData[widgetType].general.order" vs-value="d">By date</vs-radio> 
          <vs-radio class="mb-4 pr-4" v-model="widgetSettingsData[widgetType].general.order" vs-value="s">Shuffle items</vs-radio> 

        </div>
      
      </div>
        </div>
      </div>
    </div>    

    <div class="vx-card mb-base p-5">
        
      <h4 class="mb-base mt-2">General Settings</h4>              
          
      
        <div v-if="widgetType === 'generalnudge'" class="vx-row">
            <div class="vx-col w-full md:w-1/3 px-2">
              <vs-checkbox class="mb-5" v-model="widgetSettingsData.generalnudge.general.showVerifiedFBL">Show Feedback Link logo for feedback items</vs-checkbox>
              <vs-checkbox class="mb-4" v-model="widgetSettingsData.generalnudge.general.hideOnMobile">Hide on mobile devices</vs-checkbox>
            </div>
            <div class="vx-col w-full md:w-1/3 px-2">
              <p class="mb-4">FREQUENCY</p>
              <p class="mb-4">How often the nudge should appear.</p>
              <vs-radio
                v-model="widgetSettingsData.generalnudge.behaviour.frequency"
                vs-value="i"  
                class="mb-4 w-full"                        
              >Insistent</vs-radio>
              <vs-radio
                v-model="widgetSettingsData.generalnudge.behaviour.frequency"
                vs-value="c"  
                class="mb-4 w-full"                        
              >Composed</vs-radio>
              <vs-radio
                v-model="widgetSettingsData.generalnudge.behaviour.frequency"
                vs-value="s"  
                class="mb-4 w-full"                           
              >Subtle</vs-radio>
            </div>
            <div class="vx-col w-full md:w-1/3 p-2">
              <p class="mb-4">POSITION</p>
              <p class="mb-4">Where in the window the nudge should appear.</p>
              <vs-radio
                v-model="widgetSettingsData.generalnudge.display.position"
                vs-value="r"  
                class="mb-4 w-full"              
              >Right</vs-radio>
              <vs-radio
                v-model="widgetSettingsData.generalnudge.display.position"
                vs-value="l" 
                class="mb-4 w-full"                          
              >Left</vs-radio>             
            </div>
          </div>                

          
                    
          <div v-if="widgetType !== 'generalnudge'" >
            <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 px-2">
              <vs-checkbox class="mb-5" v-model="widgetSettingsData.wallofproof.general.showVerifiedFBL">Show Feedback Link logo for feedback items</vs-checkbox>
            </div>
            <div class="vx-col w-full md:w-1/2 px-2">              
              <div class="flex">
                <vs-checkbox class="mb-5" v-model="widgetSettingsData.wallofproof.general.includeItemLink">Include a link to the item source</vs-checkbox>              
                <vx-tooltip class="svglight inline-block relative float-right" style="top:0.2rem;margin-left:0.1rem;" text="When clicked, visitors can view the original source review/content of an item (link will open in a new window).">
                  <small class="flex cursor-pointer">
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4 text-light"></feather-icon>
                  </small>
                </vx-tooltip>
              </div>
            </div>
            </div>
            



            <vs-collapse type="margin" class="small w-full bg-white" v-if="widgetType === 'carousel'">
              <vs-collapse-item icon-pack="feather" :open="true" icon-arrow="icon-chevron-down" class="w-full p-0 relative">
              <div slot="header" class="text-left">
                Slider Settings
              </div>
              <div class="p-4">
                <div class="vx-row">
                  <div class="vx-col w-full md:w-1/2">
                    <div>
                      <p class="mb-2">Automatically slide through items?</p>
                      <vs-checkbox class="pr-6 mb-4" v-model="widgetSettingsData.carousel.display.autoPlay">Auto play</vs-checkbox>                                            
                    </div>                    
                  </div>
                  <div class="vx-col w-full md:w-1/2">                    
                    <p class="mb-2">Autoplay speed (seconds)</p>
                      <vs-input name="'Autoplay speed'" v-validate="'required|between:2,20'" v-model="widgetSettingsData.carousel.display.autoPlaySpeed" type="number" min="2" max="20"/>
                      <span class="text-light text-sm">Show new slide every {{ widgetSettingsData.carousel.display.autoPlaySpeed }} seconds</span>
                  </div>
                </div>
              </div>
            </vs-collapse-item>
            </vs-collapse>






            
            <vs-collapse type="margin" class="small w-full bg-white" v-if="widgetType === 'wallofproof'">
            <vs-collapse-item icon-pack="feather" :open="true" icon-arrow="icon-chevron-down" class="w-full p-0 relative">
            <div slot="header" class="text-left">
              Advanced Settings
            </div>
            <div class="p-4">
              <div class="vx-row">
                <div class="vx-col w-full md:w-1/2">
                  <p class="mb-4">COLUMNS</p>
                  <p class="mb-4">Number of columns <vx-tooltip class="svglight inline-block relative" style="top:0.2rem;margin-left:0.1rem;" text="How many columns to display items in. We recommend 'Automatic', which means the widget will adapt to the best possible grid layout.">
                  <small class="flex cursor-pointer">
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4 text-light"></feather-icon>
                  </small>
                </vx-tooltip></p>                                    
                  <div class="mb-4">
                    <vs-checkbox v-model="widgetSettingsData.wallofproof.display.autoColumns">
                      Automatically adjust columns based on view size
                    </vs-checkbox>
                    <vs-input name="'Number of columns'" v-validate="'required|between:1,5'" class="mt-4" v-if="!widgetSettingsData.wallofproof.display.autoColumns" v-model="widgetSettingsData.wallofproof.display.customNoColumns" type="number" min="1" max="5"/>
                    <p class="my-4">
                      Note that mobile and tablet widths will still adapt to one column.
                    </p>
                    <p class="my-4" v-if="!widgetSettingsData.wallofproof.display.autoColumns && Number(widgetSettingsData.wallofproof.display.customNoColumns) === 1">
                      If you select a single column layout, note that items will have a max-width of 500px.
                    </p>
                  </div>                  
                </div>
                <div class="vx-col w-full md:w-1/2">
                  <p class="mb-4">DISPLAY SETTINGS</p>
                  <div class="mb-4">
                    <p class="mb-2">Number of items to show on first load (max 20)</p>
                    <vs-input name="'Number of items to show'" v-validate="'required|between:1,20'"  v-model="widgetSettingsData.wallofproof.display.itemsToShowOnLoad" type="number" min="1" max="20"/>
                  </div>
                  <div class="mb-4 mt-6">
                    <p class="mb-2">"Load more" Button text</p>
                    <vs-input name="'Load more button text'" v-validate="'required|max:26'" v-model="widgetSettingsData.wallofproof.display.text.loadMoreButton" placholder="Load more"/>
                    <span class="mt-2 text-danger" v-if="errors.first('Load more button text')">{{ errors.first('Load more button text') }}</span>
                  </div>  
                   
                </div>
              </div>
            </div>
          </vs-collapse-item>
          </vs-collapse>



        </div>       
      </div>

   
    <div class="vx-card mb-base p-5">      
      <h4 class="mb-base mt-2">Display Settings</h4>      
      <div class="vx-row">              
          <div class="vx-col w-full md:w-1/3 mb-6 flex">
            <div class="flex-1 pr-2">
              <p class="mb-4">COLOR</p>
              <chromepicker class="w-full" v-model="widgetSettingsData[widgetType].display.pmyColor" :disableAlpha="true"/>            
            </div>                        
          </div>      
          <div class="vx-col w-full md:w-1/3 mb-6">
            <p class="mb-4">PROFILE PICTURES</p>            
            <p>Show/hide</p>
            <vs-radio class="w-full my-3" vs-value="onlyifimage" v-model="widgetSettingsData[widgetType].display.avatars.showSetting">Show only if picture present</vs-radio>
            <vs-radio class="w-full my-3" vs-value="never" v-model="widgetSettingsData[widgetType].display.avatars.showSetting">Don't show</vs-radio>            
            <vs-divider/>
            <p>Initials badges</p>
            <vs-radio class="w-full my-3" vs-value="outline" v-model="widgetSettingsData[widgetType].display.avatars.showSetting">Colored - Outline</vs-radio>
            <vs-radio class="w-full my-3" vs-value="fill" v-model="widgetSettingsData[widgetType].display.avatars.showSetting">Colored - Filled</vs-radio>                        
          </div>
      </div>                        
    </div>
   

   <div class="vx-card mb-base p-5">      
      <h4 class="mb-base mt-2">Date Settings</h4>      
      <div class="vx-row">      
        <div class="vx-col w-full md:w-1/2 mb-6">
          <p class="mb-4">DATE VISIBILITY</p>
          <vs-checkbox class="pr-6 mb-4" v-model="widgetSettingsData.date.show">Show date</vs-checkbox>
          <div v-if="widgetSettingsData.date.show">
            <vs-checkbox class="pr-6 mb-4" v-model="widgetSettingsData.date.hideBeforeTime">Hide any date older than:</vs-checkbox>
            <date-picker :class="{'opacity-25': !widgetSettingsData.date.hideBeforeTime}" :editable="false" class="w-full cursor-pointer" v-model="widgetSettingsData.date.timeBeforeS" valueType="timestamp" placeholder="Select date"></date-picker>
          </div>
        </div>   


        <div class="vx-col w-full md:w-1/2" v-if="widgetSettingsData.date.show">            
          <p class="mb-4">DATE FORMAT</p>
          <vs-radio class="w-full my-4" vs-value="lf" v-model="widgetSettingsData.date.format">Mmm, DD, YYYY</vs-radio>
          <vs-radio class="w-full my-4" vs-value="sf" v-model="widgetSettingsData.date.format">DD/MM/YY</vs-radio>
        </div>


      </div>
    </div>  
   


  <div class="vx-card mb-base p-5" v-if="!$store.getters['dash/showcaseOriginSets']">
      <h4 class="mb-base mt-2">Domain settings</h4>      
      <div class="vx-row">        
        <div class="vx-col w-full md:w-1/2">          
          <DomainSettings :domainSettingsUpdated="domainSettingsUpdated"/>      
        </div>
      </div>    
  </div>

    <savebutton cancelText="Cancel" :goodToGo="!waiting" :cancel="() => { $router.push('/dash/showcase') }" :submitText="isWidgetEditID ? 'Update Widget' : 'Create Widget'" :accept="createUpdateWidget" />

  </div>
</template>

<script>

/*

<div class="flex-1 pr-2">
              <p class="mb-4">BADGE COLOR</p>
              <chromepicker class="w-full" v-model="widgetSettingsData[widgetType].display.sdyColor" :disableAlpha="true"/>            
            </div>            


*/

import DomainSettings from './Components/DomainSettings.vue'

import Savebutton from "../components/ptcomponents/Savebutton.vue";
import { Chrome } from 'vue-color'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';




const hexToColorObject = (hex) => {
  // Remove '#' if it exists
  hex = hex.replace('#', '');

  // Parse RGB values from hex
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate HSL
  const hsl = rgbToHsl(r, g, b);
  
  // Calculate HSV
  const hsv = rgbToHsv(r, g, b);
  
  return {    
      hsl: hsl,
      hex: `#${hex.toUpperCase()}`,
      hex8: `#${hex.toUpperCase()}FF`,
      rgba: { r, g, b, a: 1 },
      hsv: hsv,
      oldHue: hsl.h, // You can replace this value as you see fit
      source: 'hex',
      a: 1
  };
};

const rgbToHsl = (r, g, b) => {
  r /= 255, g /= 255, b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; 
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  return { h: h * 360, s, l, a: 1 };
};

const rgbToHsv = (r, g, b) => {
  r = r / 255;
  g = g / 255;
  b = b / 255;
  
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const d = max - min;
  const s = max === 0 ? 0 : d / max;
  let h;

  if (max === min) {
    h = 0;
  } else {
    switch(max){
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  return { h: h * 360, s, v: max, a: 1 };
};












export default {
  data() {
    return {
      waiting: false,
      widgetType: "wallofproof",
      widgetName: '',      
      //if there is not domain settings set, form will ask for it
      domainSettings: {
        domainBase: '',
        subs: []
      },

      loadedWidgetData: '',
      widgetSettingsData: {        
        items: {
          showAllTags: true,
          showOnlyTags: [...this.$store.state.dash.viewData.currentTags]          
        },
        date: {
              show: true,
              timeBeforeS: null, 
              hideBeforeTime: false,
              format:
                this.$store.getters["dash/currentLanguagePackName"] === "en"
                  ? "lf"
                  : "sf",
        },
        
        
        carousel: {
          //B.E. type: "wallofproof",          
            general: {
              showVerifiedFBL: true,
              includeItemLink: false,
              order: "d",
            },
            display: {
              pmyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex,
              sdyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
              avatars: {
                 showSetting: 'outline' //'fill' | 'never' | 'onlyifimage'
              },
              customMaxColumns: 1, //not used currently
              autoPlay: true,
              autoPlaySpeed: 5,
              autoColumns: true,
              itemsToShowOnLoad: 20             
            }
        },
        
        
        wallofproof: {
          //B.E. type: "wallofproof",          
            general: {
              showVerifiedFBL: true,
              includeItemLink: false,
              order: "d",
            },
            display: {
              pmyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex,
              sdyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
              avatars: {
                 showSetting: 'outline' //'fill' | 'never' | 'onlyifimage'
              },
              customNoColumns: 1,
              autoColumns: true,
              itemCharLimit: 100,
              itemsToShowOnLoad: 20,
              text: {
                loadMoreButton:
                  typeof this.$store.getters["dash/currentLanguagePack"].loadMore ===
                  "undefined"
                    ? "Load more"
                    : this.$store.getters["dash/currentLanguagePack"].loadMore,
              },
            }
        },
        generalnudge: {
          //B.E. type: "generalnudge",
            general: {
              showVerifiedFBL: true,
              hideOnMobile: false,
              order: "d",
            },            
            behaviour: {
              frequency: "c",
            },
            display: {
              pmyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex,
              sdyColor: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
              avatars: {
                 showSetting: 'outline' //'fill' | 'never' | 'onlyifimage'
              },
              position: "r",
            }            
        },
      }
      }
    },
    computed: {
      isWidgetEditID() {        

      const recievedParam = this.$route.params.widgettypeorid

      if (
        recievedParam !== 'choose' &&
        recievedParam !== 'wallofproof' &&
        recievedParam !== 'carousel' &&
        recievedParam !== 'generalnudge' 
      ) return this.$route.params.widgettypeorid
        
      return false

      }
    },
  components: {
    DomainSettings,
    DatePicker,
    Savebutton,
    chromepicker: Chrome
  }, 
  methods: {
    domainSettingsUpdated (v) {

      this.domainSettings.subs = [...v.subs.map(itm => itm.text)]
      this.domainSettings.domainBase = v.domainBase

    },
    formHasErrors () {

       if (this.errors.any()) return this.errors.all()[0]

      //check name
      this.widgetName = this.widgetName.trim()
      if (this.widgetName.length === 0) return 'Your widget needs a name!'
      if (this.widgetName.length > 40) return 'Widget name can\'t be more than 40 characters.'

      //check loadButton
      if (this.widgetType === 'wallofproof') {        
        if (this.widgetSettingsData.wallofproof.display.text.loadMoreButton.length > 26) return '\'Load more\' button text can\'t be more than 26 characters.'        
      }
      
      
      if (!this.$store.getters['dash/showcaseOriginSets']) {

          //domain settings need to be provided here
          
          //validate it

          this.domainSettings.domainBase = this.domainSettings.domainBase.trim()

          const dotIndex = this.domainSettings.domainBase.indexOf('.')

          if (
            this.domainSettings.domainBase.length === 0 || 
            dotIndex == 0 || 
            dotIndex == -1 || 
            this.domainSettings.domainBase.length === dotIndex + 1
            ) return 'We need a valid main domain for where your widgets will be hosted.'


          try {
            const dmn = new URL('https://' + this.domainSettings.domainBase)
          } catch (e){
            return 'Invalid main domain: We need a valid main domain for where your widgets will be hosted.'
          }          


          const theSubs = [...this.domainSettings.subs]

          theSubs.forEach((sub,i) => {
            if (sub.length === 0) this.domainSettings.subs.splice( i, 1)
          })
          
      }
      


      //B/E:
       // maximum and minimums adhered to
       // cut off lengths if needed
       //remove possible illegal chars. from domains

    },
    createUpdateWidget() {

      const error = this.formHasErrors()

      if (error) {
        this.$vs.notify({
            title: '',
            text: error,
            color: 'warning',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 
        return  
      }          
      
      const isUpdateID = this.isWidgetEditID

      let toSend = JSON.parse(JSON.stringify(this.$data))

      //if no domain settings asked before, also include domain settings in payload
      // or exclude if there is domain settings
      if (this.$store.getters['dash/showcaseOriginSets']) {
        delete toSend.domainSettings
      }

      //validate tags
      if (toSend.widgetSettingsData.items.showAllTags) {
        toSend.widgetSettingsData.items.showOnlyTags = []
      } else {
        if (toSend.widgetSettingsData.items.showOnlyTags.length === 0) {
          toSend.widgetSettingsData.items.showAllTags = true
        }
      } 

      //convert datepicker time
      if (toSend.widgetSettingsData.date.timeBeforeS) {
        toSend.widgetSettingsData.date.timeBeforeS = toSend.widgetSettingsData.date.timeBeforeS / 1000
      }

      this.$vs.notify({
              title: '',
              text: isUpdateID ? 'Updating widget...' : 'Creating widget...',
              color: 'primary',
              time: 2500,
              iconPack: 'feather',
              icon:'icon-info'
            }) 

      this.waiting = true

      if (isUpdateID) {
        toSend = {
          uiData: toSend,
          widgetID: isUpdateID
        }
      }

      this.$store.dispatch(`dash/${isUpdateID ? 'UPDATE_WIDGET' : 'CREATE_WIDGET'}`, toSend).then((results) => {

          //resync widget data
          this.$store.dispatch('dash/SYNC_WIDGETS').finally(() => {

            this.$store.dispatch('dash/BUILD_WIDGET', isUpdateID ? [isUpdateID] : [results.newWidgetID])

            this.$vs.notify({
              title: isUpdateID ? 'Widget Updated' : 'Widget Created',
              text: 'Please allow for up to 5mins. for changes to reflect on your website.',
              color: 'success',
              time: 15000,
              iconPack: 'feather',
              icon:'icon-check'
            }) 
            
            this.$router.push(`/dash/showcase/${isUpdateID ? '' : results.newWidgetID}`)

          })

      }).catch(() => {
        this.waiting = false

        this.$vs.notify({
            title: isUpdateID ? 'Update widget' : 'Create widget',
            text: `Oops! There was a problem while trying to ${isUpdateID? 'update':'create'} your widget. Please try again or reach out to support.`,
            color: 'warning',
            time: 12500,
            iconPack: 'feather',
            icon:'icon-alert-circle'
        }) 


      })
         
    }

  },
 
  created() {    

    let fail = false
    const wParam = this.$route.params.widgettypeorid
    if (typeof wParam === 'undefined') fail = true    

    if (fail) this.$router.push('/dash/showcase')

    if (this.isWidgetEditID) {
      //editing widget, see if it exists

      let foundIt = false

      this.$store.state.dash.viewData.currentWidgets.forEach((wdgt) => {

        

        if (wParam === wdgt.widgetID) {

            const w = JSON.parse(JSON.stringify(wdgt))

            //found it, populate view
            foundIt = true

            this.widgetType = w.type
            this.widgetName = w.name

            this.widgetSettingsData.items.showAllTags = w.showAllTags
            this.widgetSettingsData.items.showOnlyTags = w.showOnlyTags            

            //avatar settings may not be on b/e, add it artificially:
            if (typeof w.config.display.avatars === 'undefined') {
              w.config.display.avatars = {}
              w.config.display.avatars.showSetting = 'outline'
            } 


            //prep display:
            w.config.display.pmyColor = hexToColorObject(w.config.display.pmyColor)
            w.config.display.sdyColor = hexToColorObject(w.config.display.sdyColor)


            if (w.type === 'generalnudge') {
              
              Object.assign(this.widgetSettingsData.date, w.config.date) 

              //transform date timeS
              if (this.widgetSettingsData.date.timeBeforeS) this.widgetSettingsData.date.timeBeforeS = this.widgetSettingsData.date.timeBeforeS * 1000

              Object.assign(this.widgetSettingsData.generalnudge.general, w.config.general)
              Object.assign(this.widgetSettingsData.generalnudge.behaviour, w.config.behaviour)                            
              Object.assign(this.widgetSettingsData.generalnudge.display, w.config.display)

            } 

            if (w.type === 'wallofproof') {
              
              
              Object.assign(this.widgetSettingsData.date, w.config.date) 

              //transform date timeS
              if (this.widgetSettingsData.date.timeBeforeS) this.widgetSettingsData.date.timeBeforeS = this.widgetSettingsData.date.timeBeforeS * 1000

              Object.assign(this.widgetSettingsData.wallofproof.general, w.config.general)                            
              Object.assign(this.widgetSettingsData.wallofproof.display, w.config.display)
              Object.assign(this.widgetSettingsData.wallofproof.display.text, w.config.display.text)

            } 

        }

      })

      if (!foundIt) this.$router.push('/dash/showcase')


    } else {
      if (wParam === 'wallofproof' || wParam === 'choose') this.widgetType = 'wallofproof'
      if (wParam === 'generalnudge') this.widgetType = 'generalnudge'
      if (wParam === 'carousel') this.widgetType = 'carousel'
    }

  }   
}
</script>


<style lang="scss">
</style>